import Vue from "vue";
import VueI18n from "vue-i18n";

import messages from "./traducao/index";

Vue.use(VueI18n);

// Vue -> canônico (usado pelo React). React -> Vue (restauração no boot).
export const REACT_LOCALE_MAP: Record<string, string> = {
    "pt-br": "pt-BR",
    "en-us": "en-US",
    es: "es",
};

const VUE_LOCALE_MAP: Record<string, string> = {
    "pt-BR": "pt-br",
    "en-US": "en-us",
    es: "es",
};

const idiomaSalvo = localStorage.getItem("@PharmUP:Language");
const locale = (idiomaSalvo && VUE_LOCALE_MAP[idiomaSalvo]) || "pt-br";

const i18n = new VueI18n({
    locale,
    fallbackLocale: "pt-br",
    messages,
});

export default ({ app }) => {
    app.i18n = i18n;
};

export { i18n };
